import React, { useState, useContext, useEffect } from 'react'

import { Input } from './Input'
import StartScreenHeader from './StartScreenHeader'
import { setBorderColor, styleByScreenSize, setBackgroundColor } from './config'
import { validationLettersOnly } from '../../../helper/validationLettersOnly'

import classes from './styles.module.scss'
import { WebSocketsSharedContext } from '../../../integrations/WebSockets'
import widgetStorage from '../../../actions/storage'

const StartScreen = ({
  device,
  settings,
  greeting,
  updateUserData,
  popupWasShow,
}) => {//NOSONAR
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState({
    name: '',
    email: '',
  })
  const { initializeConversation } = useContext(WebSocketsSharedContext) || {}
  const { isRtl: rtl } = settings

  useEffect(() => {
    const user = widgetStorage.tryFindUserInfoInAnyStorage()
    if (user) {
      const userObj = JSON.parse(user)
      setName(userObj.name)
      setEmail(userObj.email)
    }
  }, [])

  const onChange = (name, event) => {
    if (name === 'name') {
      setName(event.target.value.trimStart())
    } else if (name === 'email') {
      setEmail(event.target.value.trimStart())
    }
  }

  const submitSignUp = event => {
    if (event) event.preventDefault()
    const err = Object.assign({}, errors)
    if (name) {
      err.name = validationLettersOnly(name) ? settings.nameInputError : ''
    }
    err.name = name ? err.name : settings.nameInputError
    if (email) {
      err.email = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(email)
        ? ''
        : settings.emailInputError
    }
    err.email = email ? err.email : settings.emailInputEmptyError

    setErrors(err)
    const nameValidation = settings.isLoginNameInputEnabled ? !err.name : true
    const emailValidation = settings.isLoginEmailInputEnabled
      ? !err.email
      : true

    if (nameValidation && emailValidation) {
      signUpCallBack({ err, email: email.trim(), name: name.trim() })
      widgetStorage.setUserInfo(JSON.stringify({ name: name.trim(), email: email.trim() }))
    }
  }

  const signUpCallBack = ({ email, name }) => {
    const user = {}
    if (settings.isLoginNameInputEnabled && name) {
      user.name = name
    }

    if (settings.isLoginEmailInputEnabled && email) {
      user.email = email
    }

    updateUserData(user)
    handleInitialize()
  }

  const handleInitialize = () => {
    if (greeting?.payload && popupWasShow) {
      const message = {
        type: 'postback',
        payload: greeting.payload,
        isRtl: false,
      }
      initializeConversation(message)
    } else {
      initializeConversation()
    }
  }

  const buttonStyle = {
    ...setBorderColor(settings.color),
    ...setBackgroundColor(settings.color),
  }

  return (
    <div className={classes.container} style={styleByScreenSize(device.width)}>
      <StartScreenHeader settings={settings} />
      <form onSubmit={submitSignUp} className={classes.formContainer}>
        <p className={classes.description} dir={rtl ? 'rtl' : 'ltr'}>
          {settings.isLoginEmailInputEnabled || settings.isLoginNameInputEnabled
            ? `${settings.startLabel}`
            : ''}
        </p>
        {!settings.isLoginEmailInputEnabled &&
          settings.isLoginNameInputEnabled && (
          <div className={classes.inputHolderOneFiled}>
            <Input
              type="text"
              placeholder={settings.nameInputPlaceholder}
              name={name}
              classes={classes.secondaryInput}
              error={errors.name}
              onChange={value => onChange('name', value)}
              rtl={rtl}
              id="widget-login-name-input"
            />
            {errors.name && (
              <p
                className={classes.validationDescription}
                dir={rtl ? 'rtl' : 'ltr'}>
                {errors.name}
              </p>
            )}
            <button
              className={classes.buttonInput}
              style={buttonStyle}
              type="submit"
              id="widget-start-button">
              {settings.startButton}
            </button>
          </div>
        )}
        {settings.isLoginEmailInputEnabled &&
          !settings.isLoginNameInputEnabled && (
          <div className={classes.inputHolderOneFiled}>
            <Input
              type="text"
              placeholder={settings.emailInputPlaceholder}
              onChange={event => onChange('email', event)}
              classes={classes.secondaryInput}
              name={email}
              error={errors.email}
              rtl={rtl}
              id="widget-login-email-input"
            />
            {errors.email && (
              <p
                className={classes.validationDescription}
                dir={rtl ? 'rtl' : 'ltr'}>
                {errors.email}
              </p>
            )}
            <button
              className={classes.buttonInput}
              style={buttonStyle}
              type="submit"
              id="widget-start-button">
              {settings.startButton}
            </button>
          </div>
        )}
        {settings.isLoginEmailInputEnabled && settings.isLoginNameInputEnabled && (
          <>
            <div className={classes.inputsWrap}>
              <div>
                <Input
                  type="text"
                  placeholder={settings.nameInputPlaceholder}
                  name={name}
                  error={errors.name}
                  classes={classes.input}
                  onChange={event => onChange('name', event)}
                  rtl={rtl}
                  id="widget-login-name-input"
                />
                {errors.name && (
                  <p
                    className={classes.validationDescription}
                    dir={rtl ? 'rtl' : 'ltr'}>
                    {errors.name}
                  </p>
                )}
              </div>
              <div>
                <Input
                  type="text"
                  placeholder={settings.emailInputPlaceholder}
                  name={email}
                  error={errors.email}
                  classes={classes.input}
                  onChange={event => onChange('email', event)}
                  rtl={rtl}
                  id="widget-login-email-input"
                />
                {errors.email && (
                  <p
                    className={classes.validationDescription}
                    dir={rtl ? 'rtl' : 'ltr'}>
                    {errors.email}
                  </p>
                )}
              </div>
            </div>
            <button
              className={classes.button}
              style={buttonStyle}
              type="submit"
              id="widget-start-button">
              {settings.startButton}
            </button>
          </>
        )}
      </form>
    </div>
  )
}

export default StartScreen
